<template>
  <lb-drawer
    :value="visible"
    heading="Change Information Owner"
    width="400"
    :loading="loading"
    data-testid="change-info-owner-drawer"
    @input="$emit('update:visible', $event)"
  >
    <template #body>
      <div data-testid="change-info-owner-drawer__body">
        <v-row>
          <v-col cols="12" class="my-0 py-1">
            <lb-dropdown
              :value="changeType"
              label="Type*"
              :items="changeTypeOptions"
              itemtext="name"
              itemvalue="value"
              data-testid="change-info-owner-drawer__type"
              @input="$emit('update:changeType', $event)"
            />
          </v-col>
          <v-col v-if="changeType === 'existing'" cols="12" class="my-0 py-1">
            <lb-dropdown
              label="New Owner*"
              :value="form.newownerid"
              :items="possibleOwners"
              itemtext="displayName"
              itemvalue="_id"
              data-testid="change-info-owner-drawer__newowner"
              @input="updateField('newownerid', $event)"
            />
          </v-col>
          <v-col v-if="changeType === 'new'" cols="12" class="my-0 py-1">
            <lb-string
              label="Name*"
              :value="form.name"
              data-testid="change-info-owner-drawer__name"
              @input="updateField('name', $event)"
            />
          </v-col>
          <v-col v-if="changeType === 'new'" cols="12" class="my-0 py-1">
            <lb-string
              label="Email*"
              :value="form.email"
              data-testid="change-info-owner-drawer__email"
              @input="updateField('email', $event)"
            />
          </v-col>
        </v-row>
      </div>
    </template>
    <template #actions>
      <span class="caption">*Required</span>
      <v-spacer />
      <v-btn
        color="primary"
        class="white--text"
        :disabled="!canSubmit"
        data-testid="change-info-owner-drawer__update-btn"
        @click="$emit('submit')"
      >
        <span data-testid="change-info-owner-drawer__update-label">Update</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
const CHANGE_TYPE_OPTIONS = [
  { name: 'New', value: 'new' },
  { name: 'Existing', value: 'existing' }
];

export default {
  name: 'ChangeInfoOwnerDrawer',
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    changeType: { type: String, default: 'existing' },
    form: { type: Object, default: () => ({}) },
    possibleOwners: { type: Array, default: () => [] }
  },
  emits: ['update:visible', 'update:changeType', 'update:form', 'submit'],
  data() {
    return {
      changeTypeOptions: CHANGE_TYPE_OPTIONS
    };
  },
  computed: {
    canSubmit() {
      return Boolean(
        this.form?.newownerid || (this.form?.name && this.form?.email)
      );
    }
  },
  methods: {
    updateField(key, value) {
      this.$emit('update:form', { ...this.form, [key]: value });
    }
  }
};
</script>
